import React from 'react'
import { IconButton, styled } from '@mui/material'
import ChevronIcon from '@mui/icons-material/ChevronRight'

const StyledExpandButton = styled(IconButton)(({ theme }) => ({
  transform: 'rotate(90deg)',
  transition: '200ms',
  '&.expanded': {
    transform: 'rotate(-90deg)',
  },
}))

const ExpandButton = ({ expanded, onClick }) => {
  return (
    <StyledExpandButton onClick={onClick} className={expanded ? 'expanded' : ''}>
      <ChevronIcon />
    </StyledExpandButton>
  )
}

export default ExpandButton
